/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Layout, Main } from '../AdminTeamCreation/styles';
import AboutChallengePopup from './AboutChallengePopup';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { fethcChallengeByChallengeType, getActivityChallengeById, deleteChallengeLibrary } from '../../redux/actions';
import _ from 'lodash';
import Waiting from '../Waiting';
// import { ChallengeHeading } from "../CreateEvent/style";
import { ToolTip } from "../AdminTeamCreation/styles";
import HoverButton from '../common/HoverButtonV2';
// import { BackIcon, CreateChallenge } from '../../utils/icons';
import {CategoryWrapper, CategoryCard} from './styles';
import Thumbnail from './../Thumbnail';
import { ImageUrl } from "../../utils/constants";
import {AdminLeftArrowIcon, AddIconBranding, LaunchIcon } from "../../utils/icons";
import { Popover } from "react-bootstrap";
import DeletePopup from '../ChallengeDetailsV2/challengeLeavePopup';
import parse from 'react-html-parser';
import {Heading} from '../RecogntionAdmin/corevalues/styles'
import { ManagerIconContainer } from "../Manager/styles";
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { VerticalDotsIcon } from '../../utils/icons';
import { DownAngleV2 } from '../SocialFeedsV2/styles';

class ChallengesChallengeLibrary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAboutPopup:false,
      onHover: -1,
      showDeletePopup:false,
      deleteId:null,
      deleteType:null
    }
  }

  componentDidMount() {
    const { fethcChallengeByChallengeType, history } = this.props;
    const StringArray = history.location.pathname.split('/');
    if (StringArray[(StringArray.length - 1)] != '') {
      fethcChallengeByChallengeType(StringArray[(StringArray.length - 1)]);
    } else {
      fethcChallengeByChallengeType(StringArray[(StringArray.length - 2)]);
    }
  }

  componentDidUpdate(prevProps) {
    const { history, fethcChallengeByChallengeType } = this.props;
    const StringArray = history.location.pathname.split('/');
    if (history.location.pathname !== prevProps.history.location.pathname) {
      if (StringArray[(StringArray.length - 1)] != '') {
        fethcChallengeByChallengeType(StringArray[(StringArray.length - 1)]);
      } else {
        fethcChallengeByChallengeType(StringArray[(StringArray.length - 2)]);
      }
    }
  }

  redirection = () => {
    const { history } = this.props;
    history.push('/company/challenges/create-activty')
  };

  showPastEvents = (path) => {
    this.props.history.push(path);
  };

  onEnterMouse = (id) => {
    this.setState({
      onHover: id
    })
  };

  onLeaveMouse = () => {
    this.setState({
      onHover: -1
    })
  };

  showAboutChallengePopup = (id) => {
    this.props.getChallengeDetails(id).then(()=>{this.setState({
      showAboutPopup: true
    })});
  };

  hideAboutChallengePopup = () => {
    this.setState({
      showAboutPopup: false
    })
  };

  showDeletePouup = (id, type) => {
    this.setState({
      showDeletePopup: true,
      deleteId:id,
      deleteType:type
    })
  };

  hideDeletePouup = () => {
    this.setState({
      showDeletePopup: false
    })
  };

  deleteLibraryData = () => {
    this.setState(
      {
        showDeletePopup:false
      },
      () => {
        const { history } = this.props;
        const StringArray = history.location.pathname.split('/');
        this.props.deleteChallengeLibrary(this.state.deleteType, this.state.deleteId,StringArray[(StringArray.length - 1)]);
      }
    );
  };

  popover = (text) => (
    <Popover id="popover-basic"
      style={{
        width: "100%",
        padding: "9px 14px",
        background: "#FFFFFF",
        border: "1px solid #002F47",
        boxShadow: "0px 13px 28px rgba(0, 0, 0, 0.3)",
        borderRadius: "6px",
        zIndex:"400"
      }}  
    >
      <div  style={{
        fontFamily: "Rubik",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "20px",
        color: "#002F47",
        textAlign: "center",
        zIndex:"400"
      }}>{parse(text)}
      </div>
    </Popover> );

  renderHeading = (name) => (
    <Heading color={"#184A61"}>
      <div className="close-icon" onClick={this.props.history.location.pathname.includes("/company/challenges/categories")?() => this.props.history.push('/company/challenges/categories'):() => this.props.history.push('/challenges/categories')}>
        <ManagerIconContainer isWidth={"34px"}>{AdminLeftArrowIcon('#F37A65')}</ManagerIconContainer> 
      </div>
      {name} {this.props.t(`${name=="Monthly Challenge Series" ? "" : 'Challenges'}`)} 
      <div className='end-card'>

        {this.props.role=="ADMIN"&&<ToolTip
          margin={"auto 15px auto auto"}
          activeValue={"transparent"}
          height="40px"
          width="55px"
        >
          <HoverButton
            title={this.props.t("Create Challenge")}
            width="16px"
            height="16px"
            svgPath={<AddIconBranding/>}
            onClick={this.props.history.location.pathname.includes("/company/challenges/categories")?() => this.props.history.push('/company/challenges/create-activty'):() => this.props.history.push('/challenges/create-activty') }
            activeColor={"#F37A65"}
            inActiveColor={"#F37A65"}
            backgroundColor={"white"}
            backgroundColorActive={"#F37A65"}
          />
        </ToolTip>}
      </div>
    </Heading>
  );

  render() {
    const { challengeByType, challengeDetails, userName, history, role, t } = this.props;
    const { showAboutPopup, onHover, showDeletePopup, deleteId} = this.state;
    if (_.isNull(challengeByType)|| _.isUndefined(challengeByType)) {
      return <Waiting />
    }
    const StringArray = history.location.pathname.split('/');
    const challengeName = StringArray[(StringArray.length - 1)]=="new_group"?"Charity":StringArray[(StringArray.length - 1)]=="group"?"Classic":StringArray[(StringArray.length - 1)]=="survivor"?"Survivor":StringArray[(StringArray.length - 1)]=="charity"?"Charity":StringArray[(StringArray.length - 1)]=="monthly_theme"?"Monthly Challenge Series" : "Team";
    
    return (
      <Layout>
        <Main>
          {this.renderHeading(challengeName)}
          <CategoryWrapper>
            {challengeByType && challengeByType.length ? challengeByType.map((category, index) => (
              <CategoryCard key={index} background={"#F37A65"} color="#FEFEFE" margin={(index+1)%3===0?"0 0px 25px 0":"0 25px 25px 0"}>
                <div className="image" onMouseEnter={() => this.onEnterMouse(category.id)} onMouseLeave={() => this.onLeaveMouse()}>
                  <Thumbnail
                    src={ImageUrl +"/"+category.image}
                    alt={"recommended card"}
                    height={"250px"}
                  />
                  {onHover === category.id &&
                    <div className='imageBackground'>
                      <div className="viewMore"  onClick={history.location.pathname.includes("/company/challenges/")?() => history.push(`/company/challenges/activity-launch/${category?.id}`):() => history.push(`/challenges/activity-launch/${category?.id}`)}>{
                        LaunchIcon()} {t("Launch Challenge")}
                      </div>
                    </div>
                  }
                </div>
                <div className='wrapperMain'>
                  <div className="categoryNameWrapper" >
                    <div className="challenge-title" style={{width:'auto', flexGrow:'4'}}>
                      {t(category.title)}<br/>
                      <p style={{fontSize:'16px', margin:'8px 0 0 0', fontWeight:'normal'}}>{t(category.month_name)}</p> 
                    </div>
                  
                    {role=="ADMIN" && (
                      <div className='adminCards' style={{width:'auto', flexGrow:'1', display:'block',padding:'16px'}}>
                        <DownAngleV2 feed>
                          <DropdownButton 
                            id={`dropdown-${category.id}`} 
                            title={<VerticalDotsIcon/>}
                            align="end"
                          >
                            <Dropdown.Item 
                              onClick={history.location.pathname.includes("/company/challenges/categories/")?() => history.push(`/company/challenges/activity-edit/${category.id}`):() => history.push(`/challenges/activity-edit/${category.id}`)}
                            >
                              {t("Edit Challenge")}
                            </Dropdown.Item>
                            <Dropdown.Item 
                              onClick={() => this.showDeletePouup(category.id, category.challenge_type)}
                            >
                              {t("Delete Challenge")}
                            </Dropdown.Item>
                          </DropdownButton>
                        </DownAngleV2>
                      </div>
                    )}
                  </div>
                </div>
              </CategoryCard>)): null}
          </CategoryWrapper>
          {showAboutPopup && (
            <AboutChallengePopup 
              show={showAboutPopup} 
              challengeData={challengeDetails} 
              userName={userName} 
              hideAboutChallengePopup={this.hideAboutChallengePopup} 
              history={history}
            />
          )}
          {showDeletePopup && (
            <DeletePopup
              deleteId={deleteId}
              showConfirmPopupDelete={showDeletePopup}
              showHideDeletePopup={this.hideDeletePouup}
              deleteData={this.deleteLibraryData}
              popupTitle={t("Delete Challenge")}
              popupHeading={t("Are you sure you want to delete this Challenge?")}
              showDeleteLibrary={true}
            />
          )}
        </Main>
      </Layout>
    );
  }
}

ChallengesChallengeLibrary.propTypes = {
  history: PropTypes.object,
  role: PropTypes.string,
  fethcChallengeByChallengeType: PropTypes.func,
  challengeByType: PropTypes.array,
  location: PropTypes.object.isRequired,
  getChallengeDetails: PropTypes.func,
  challengeDetails: PropTypes.array,
  userName: PropTypes.string,
  deleteChallengeLibrary: PropTypes.func,
  t: PropTypes.func
};

const mapStateToProps = (state) => ({
  challengeByType: state.challenges.challengeByType,
  challengeDetails: state.challenges.activityDetailsById,
  userName: state.profileData.firstName
})

const mapDispatchToProps = (dispatch) => ({
  fethcChallengeByChallengeType: (type) => dispatch(fethcChallengeByChallengeType(type)),
  getChallengeDetails: (id) => dispatch(getActivityChallengeById(id)),
  deleteChallengeLibrary: (type, id, category) => dispatch(deleteChallengeLibrary(type, id,category))
})  

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChallengesChallengeLibrary));